(() => {
  const configNode = document.getElementById('ea-packaging-config');
  if (!configNode || customElements.get('ea-packaging')) return;
  const config = JSON.parse(configNode.textContent);
  const valid = ['Reduced packaging', 'Gift - full packaging'];
  let saved = valid.includes(config.current) ? config.current : null;
  let desired = saved || valid[0];
  let pending = null;
  let status = '';
  let failed = false;
  let navigating = false;
  const replay = new WeakSet();
  const views = () => document.querySelectorAll('ea-packaging');
  const paint = () => {
    document.querySelectorAll('.additional-checkout-buttons, .shopify-payment-button').forEach(node => {
      node.inert = Boolean(pending) || saved !== desired;
    });
    views().forEach(view => {
    view.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = input.value === desired; });
    view.querySelector('.ea-packaging__status').textContent = status;
    view.querySelector('.ea-packaging__retry').hidden = !failed;
    view.setAttribute('aria-busy', String(Boolean(pending)));
    });
  };
  const save = () => {
    if (pending) return pending;
    if (saved === desired) return Promise.resolve();
    failed = false;
    status = config.saving;
    pending = (async () => {
      while (saved !== desired) {
        const value = desired;
        const response = await fetch(config.updateUrl + '.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Packaging preference': value } }),
          signal: AbortSignal.timeout(12000)
        });
        if (!response.ok) throw new Error('Packaging update failed');
        const cart = await response.json();
        if (cart.attributes?.['Packaging preference'] !== value) throw new Error('Packaging update not confirmed');
        saved = value;
      }
      status = config.saved;
    })().catch(error => {
      failed = true;
      status = config.error;
      throw error;
    }).finally(() => { pending = null; paint(); });
    paint();
    return pending;
  };
  customElements.define('ea-packaging', class extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('input')) return;
      paint();
      if (this.bound) return;
      this.bound = true;
      save().catch(() => {});
      this.addEventListener('change', event => {
        if (!event.target.matches('input[type="radio"]')) return;
        event.stopPropagation();
        desired = event.target.value;
        paint();
        save().catch(() => {});
      });
      this.querySelector('.ea-packaging__retry').addEventListener('click', () => save().catch(() => {}));
    }
  });
  const guarded = async (event, target, resume) => {
    if (saved === desired && !pending) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (navigating) return;
    navigating = true;
    try {
      await save();
      replay.add(target);
      resume();
    } catch (_) {
      const view = [...views()].find(node => node.getClientRects().length);
      if (view) {
        view.scrollIntoView({ block: 'center', behavior: 'smooth' });
        view.querySelector('.ea-packaging__retry').focus();
      }
    } finally { navigating = false; }
  };
  window.addEventListener('click', event => {
    const target = event.target.closest?.('button[name="add"], input[name="add"], button[name="checkout"], input[name="checkout"], [data-ocu-skip-cart="true"], a[href*="/checkout"]');
    if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
    if (replay.has(target)) { replay.delete(target); return; }
    guarded(event, target, () => target.click());
  }, true);
  window.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart(?:\/add)?\/?$/.test(new URL(form.action).pathname)) return;
    if (!form.querySelector('[name="add"]') && event.submitter?.name !== 'checkout') return;
    if (replay.has(form)) { replay.delete(form); return; }
    guarded(event, form, () => form.requestSubmit(event.submitter));
  }, true);
})();
